// Shared NMP watch URL helpers (NmpVideo block + Hero backgrounds).

const NMP_WATCH_ORIGIN = 'https://assets.nmp.nike.com';
const NMP_HOST_SUFFIXES = ['.nmp.nike.com', '.dna.nike.com'];
const IFRAME_TAG = /<iframe\b[\s\S]*?<\/iframe>/i;
const SRC_ATTR = /\bsrc\s*=\s*["']([^"']+)["']/i;

export function isTruthy(value) {
  return value === true || value === 1 || value === '1';
}

function isAllowedNmpHost(hostname) {
  if (hostname === 'nmp.nike.com') return true;
  return NMP_HOST_SUFFIXES.some((suffix) => hostname.endsWith(suffix));
}

export function streamUrlForAsset(assetKey) {
  const parts = assetKey.split('.');
  if (parts.length > 1) parts.pop();
  const id = parts.join('.');
  return `${NMP_WATCH_ORIGIN}/video/${id}/${id}.m3u8`;
}

export function extractNmpSrc(input) {
  if (!input || typeof input !== 'string') return null;
  const trimmed = input.trim();
  if (!trimmed) return null;

  const iframeMatch = trimmed.match(IFRAME_TAG);
  let candidate = iframeMatch ? (iframeMatch[0].match(SRC_ATTR) || [])[1] : trimmed;
  if (!candidate) return null;
  candidate = candidate.replace(/&amp;/g, '&');

  let url;
  try {
    url = new URL(candidate);
  } catch (e) {
    return null;
  }

  if (url.protocol !== 'https:' || !isAllowedNmpHost(url.hostname)) return null;

  const autoplay = url.searchParams.get('autoplay') === '1';
  const loop = url.searchParams.get('loop') === '1';
  const assetKey = url.searchParams.get('asset');

  if (autoplay && url.searchParams.get('muted') !== '1') {
    url.searchParams.set('muted', '1');
  }

  if (assetKey && autoplay && loop && !url.searchParams.get('url')) {
    url.searchParams.delete('asset');
    url.searchParams.set('url', streamUrlForAsset(assetKey));
  }

  return url.toString();
}

export function buildWatchUrl({
  nmpAssetId,
  nmpAutoplay,
  nmpHideControls,
  nmpMuted,
  nmpLoop,
  nmpTheme,
}) {
  const asset = String(nmpAssetId || '').trim();
  if (!asset) return null;

  const autoplay = isTruthy(nmpAutoplay);
  const loop = isTruthy(nmpLoop);
  const muted = isTruthy(nmpMuted) || autoplay;

  const url = new URL(`${NMP_WATCH_ORIGIN}/watch/index.html`);
  if (autoplay && loop) {
    url.searchParams.set('url', streamUrlForAsset(asset));
  } else {
    url.searchParams.set('asset', asset);
  }

  if (autoplay) url.searchParams.set('autoplay', '1');
  if (isTruthy(nmpHideControls)) url.searchParams.set('controls', '0');
  if (muted) url.searchParams.set('muted', '1');
  if (loop) url.searchParams.set('loop', '1');
  url.searchParams.set('theme', nmpTheme === 'nike' ? 'nike' : 'default');

  return url.toString();
}

export function nmpIframeAllow(src, allowFullscreen) {
  return [
    /[?&]autoplay=1(&|$)/.test(src) && 'autoplay',
    isTruthy(allowFullscreen) && 'fullscreen',
  ]
    .filter(Boolean)
    .join('; ');
}
